export default "__VITE_ASSET__3f96ea69__"